import { useCallback } from "react";

import { useLocation } from "react-router";

import { selectUserById } from "@app/scene/map/store/layers/userLocations/actions";

const useInitializeUserLocations = (onSelectUser: typeof selectUserById) => {
  const { search } = useLocation();

  return useCallback(() => {
    // process incoming url params
    if (search) {
      const urlParams = new URLSearchParams(search);
      const userId = urlParams.get("previewUserLocations");
      if (userId) {
        onSelectUser(parseInt(userId, 10));
        urlParams.delete("previewUserLocations");
        window.history.replaceState(
          {},
          document.title,
          `${window.location.origin}${window.location.pathname}?${urlParams.toString()}${
            window.location.hash
          }`
        );
      }
    }
  }, [onSelectUser, search]);
};

export default useInitializeUserLocations;
